export default {
  menuList: [], //* 메뉴 리스트
};
